import request from '@/utils/request'
// 获取接口地址
export const getLudpUrl = () => {
  return request.get('/customer-api/dashbord/ludp')
}
